import { render, staticRenderFns } from "./Corporate.vue?vue&type=template&id=6d462a7b&scoped=true&"
import script from "./Corporate.vue?vue&type=script&lang=js&"
export * from "./Corporate.vue?vue&type=script&lang=js&"
import style0 from "./Corporate.vue?vue&type=style&index=0&id=6d462a7b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d462a7b",
  null
  
)

export default component.exports